"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_EXPOSED_WIDTH = exports.TOOL_PANEL_HEIGHT = exports.MAX_MOBILE_WIDTH = exports.defaultUserImage = void 0;
exports.defaultUserImage = 'https://devstart.tech/sample-image.png';
exports.MAX_MOBILE_WIDTH = 768;
exports.TOOL_PANEL_HEIGHT = 37;
exports.SEARCH_EXPOSED_WIDTH = 980;
